var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(23.3 0 0 23.3 340.46 540.05)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "docker_svg__a",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(90 5.115 30.855) scale(22.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#009cde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#00577d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#00577d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00314a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#docker_svg__a)",
    d: "M44.544 37.168L33.114 25.74 27.4 31.454l5.716 5.714-5.714 5.714 5.715 5.715 11.43-11.43z",
    transform: "translate(-35.97 -37.17)",
    vectorEffect: "non-scaling-stroke"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(23.3 0 0 23.3 639.72 540)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "docker_svg__b",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(90 15.83 33) scale(40)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8dd0f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#0088c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#0088c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#003a56"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#docker_svg__b)",
    d: "M61.686 37.168l-20-20-5.714 5.714 14.286 14.286-14.286 14.286 5.715 5.714 20-20z",
    transform: "translate(-48.83 -37.17)",
    vectorEffect: "non-scaling-stroke"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCAxMDgwIDEwODAiPgogIDxnIHRyYW5zZm9ybT0ibWF0cml4KDIzLjMgMCAwIDIzLjMgMzQwLjQ2IDU0MC4wNSkiPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iMCIgeDI9IjEiIHkxPSIwIiB5Mj0iMCIgZ3JhZGllbnRUcmFuc2Zvcm09InJvdGF0ZSg5MCA1LjExNSAzMC44NTUpIHNjYWxlKDIyLjg2KSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjMDA5Y2RlIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iNTAlIiBzdG9wLWNvbG9yPSIjMDA1NzdkIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iNTAlIiBzdG9wLWNvbG9yPSIjMDA1NzdkIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iIzAwMzE0YSIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDxwYXRoIGZpbGw9InVybCgjYSkiIGQ9Ik00NC41NDQgMzcuMTY4IDMzLjExNCAyNS43NCAyNy40IDMxLjQ1NGw1LjcxNiA1LjcxNC01LjcxNCA1LjcxNCA1LjcxNSA1LjcxNSAxMS40My0xMS40M3oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNS45NyAtMzcuMTcpIiB2ZWN0b3ItZWZmZWN0PSJub24tc2NhbGluZy1zdHJva2UiLz4KICA8L2c+CiAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMjMuMyAwIDAgMjMuMyA2MzkuNzIgNTQwKSI+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImIiIHgxPSIwIiB4Mj0iMSIgeTE9IjAiIHkyPSIwIiBncmFkaWVudFRyYW5zZm9ybT0icm90YXRlKDkwIDE1LjgzIDMzKSBzY2FsZSg0MCkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzhkZDBmMSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjUwJSIgc3RvcC1jb2xvcj0iIzAwODhjMiIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjUwJSIgc3RvcC1jb2xvcj0iIzAwODhjMiIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiMwMDNhNTYiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8cGF0aCBmaWxsPSJ1cmwoI2IpIiBkPSJtNjEuNjg2IDM3LjE2OC0yMC0yMC01LjcxNCA1LjcxNCAxNC4yODYgMTQuMjg2LTE0LjI4NiAxNC4yODYgNS43MTUgNS43MTQgMjAtMjB6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDguODMgLTM3LjE3KSIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgDocker as ReactComponent };